import { IApplicationState } from '../../types/store';

export const selectBlackFridayFlag = (state: IApplicationState) => {
  return state.filters.blackFriday;
};
